import React from "react";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Typography, Chip,
} from "@mui/material";

import {
    formatMovementTypeLabel,
    formatMovementPointsText,
    getMovementPointsColor,
    getMovementChipSx,
    isPointMovementExpired,
    isExpireMovementType,
} from "../../utils/pointMovementUi";

function formatWhen(value) {
    return value ? new Date(value).toLocaleString("fr-FR") : "–";
}

/**
 * Historique des mouvements de points (EARN, EXPIRE, etc.).
 */
const PointMovementsTable = ({
    movements = [],
    loadError = null,
    emptyLabel = "Aucun mouvement enregistré.",
    unavailableLabel = "Historique indisponible.",
}) => {
    const rows = Array.isArray(movements) ? movements : [];

    return (
        <TableContainer
            component={Paper}
            elevation={0}
            sx={{ borderRadius: 2, border: "1px solid #e8ecf1" }}
        >
            <Table size="small">
                <TableHead>
                    <TableRow sx={{ backgroundColor: "#f8f9ff" }}>
                        <TableCell sx={{ fontWeight: 600, fontSize: 13 }}>Date</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: 13 }}>Type</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: 13 }}>Variation</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.length === 0 ? (
                        <TableRow>
                            <TableCell
                                colSpan={3}
                                align="center"
                                sx={{ py: 3, color: "text.secondary", fontStyle: "italic" }}
                            >
                                {loadError ? unavailableLabel : emptyLabel}
                            </TableCell>
                        </TableRow>
                    ) : rows.map((row) => (
                        <TableRow
                            key={row.id}
                            hover
                            sx={{
                                opacity: isPointMovementExpired(row) && !isExpireMovementType(row) ? 0.75 : 1,
                                bgcolor: isExpireMovementType(row) ? "#fffbeb" : undefined,
                            }}
                        >
                            <TableCell sx={{ fontSize: 13 }}>{formatWhen(row.created_at)}</TableCell>
                            <TableCell>
                                <Chip
                                    label={formatMovementTypeLabel(row)}
                                    size="small"
                                    variant="outlined"
                                    sx={getMovementChipSx(row)}
                                />
                            </TableCell>
                            <TableCell>
                                <Typography
                                    fontWeight={700}
                                    fontSize={13}
                                    color={getMovementPointsColor(row)}
                                >
                                    {formatMovementPointsText(row)}
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PointMovementsTable;
